import { useTranslations } from 'next-intl';
import { useFormattedDateLabel } from '../hooks/useFormattedDateLabel';
import { monthKeyToDate } from '../transactionDateHelpers';
import type { MonthKey } from '../types';

type MonthEmptyContentProps = { month: MonthKey; namespace: string };

function MonthEmptyContent({ month, namespace }: MonthEmptyContentProps) {
  const t = useTranslations(namespace);
  const monthLabel = useFormattedDateLabel(namespace, monthKeyToDate(month), 'month_label');
  return (
    <>
      <p className="paragraph-explanatory-strong" data-testid="month-formatted-string">
        {monthLabel}
      </p>
      <div className="flex items-center justify-center rounded-lg bg-container p-4">
        <p className="paragraph-s text-foreground-subtle" data-testid="no-transactions-content">
          {t('no_transactions')}
        </p>
      </div>
    </>
  );
}

export { MonthEmptyContent };
